import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ITriggerGrid } from '@models';
import { ODataService } from '@services/generics/odata.service';
import { MapperService } from '@services/mapper.service';

@Injectable()
export class TriggersGridService extends ODataService<ITriggerGrid, number> {
    protected _endpoint = '/odata/ProcessSchedules';
    constructor(http: HttpClient) {
        super(http, MapperService.triggerGridMap);
    }

    public setEnabled(scheduleIds: Array<number>, enabled: boolean) {
        return this._http.post(
            `${this._endpoint}/UiPath.Server.Configuration.OData.SetEnabled`,
            JSON.stringify({
                scheduleIds,
                enabled,
            }),
        );
    }
}
